import axios from "axios";

// URL de base de ton API
const BASE_URL = import.meta.env.VITE_BACKEND_URL as string;

// Instance Axios pour les requêtes publiques (sans token)
export const publicApi = axios.create({
  baseURL: BASE_URL,
  timeout: 10000, // Timeout de 10s pour éviter les requêtes bloquées
});

// Instance Axios pour les requêtes privées (avec token)
export const privateApi = axios.create({
  baseURL: BASE_URL,
});

// Instance Axios pour les requêtes privées for blob (avec token)
export const privateApiWithBlob = axios.create({
  baseURL: BASE_URL,
});

privateApi.interceptors.request.use(
  (config) => {
    config.headers["Content-Type"];
    config.headers["Access-Control-Allow-Credentials"] = true;
    config.withCredentials = true;
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

privateApiWithBlob.interceptors.request.use(
  (config) => {
    if (config.method !== "get" && config.data instanceof FormData) {
      delete config.headers["Content-Type"];
    }
    config.headers["Access-Control-Allow-Credentials"] = true;
    config.withCredentials = true;
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

publicApi.interceptors.request.use(
  (config) => {
    config.headers["Content-Type"] = "application/json";
    config.headers["Access-Control-Allow-Credentials"] = true;
    config.withCredentials = true;
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Gére les erreurs globales des requêtes privées
privateApi.interceptors.response.use(
  (response) => response, 
  (error) => {
    return Promise.reject(error);
  }
);

// Gére les erreurs globales des requêtes privées
privateApiWithBlob.interceptors.response.use(
  (response) => response, 
  (error) => {
    return Promise.reject(error);
  }
);